import { styled } from '@linaria/react';
import { breakpoints, layout, space } from '../../theme/tokens';

export const TopBarRow = styled.div`
  margin-bottom: ${space['space-1000']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-bottom: ${space['space-1200']};
  }
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-600']};
  margin-bottom: ${space['space-2400']};

  @media (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: ${space['space-1000']};
  }

  @media (min-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
